// removed by extract-text-webpack-plugin
module.exports = {"App":"GpIUyvkw","MenuOpen":"_1h7-Mp5j"};


//////////////////
// WEBPACK FOOTER
// ./src/application.styles.scss
// module id = 593
// module chunks = 0